import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import clsx from "clsx";
import { Dropdown, Tag } from "@client/shared/components";
import { globalStyles, noop,DELIVERY_TYPE } from "@client/shared/constants";

import style from "./style";

const NotificationCardView = ({
  notification = {},
  areAllSelected = false,
  onSelectionChange = noop,
  onToggle = noop,
  onCardClick = noop,
  onMoreActionsChange = noop,
  selectedRows = [],
}) => {
  const isSelected = selectedRows.includes(notification.id);
  return (
    <>
      <Paper
        sx={
          areAllSelected || !!isSelected
            ? {
                ...style.wrapper,
                ...style.selectionShadow,
                paddingTop: 1,
                padding: 2,
                position: "relative",
                margin: "20px",
              }
            : {
                ...style.wrapper,
                paddingTop: 1,
                padding: 2,
                position: "relative",
                margin: "20px",
              }
        }
        elevation={notification.enabled ? 4 : 0}
        variant={notification.enabled ? "elevation" : "outlined"}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={areAllSelected || !!isSelected}
                disabled={notification.isDisabled}
                disableRipple
                size="small"
                onChange={(event) => {
                  // event.preventDefault();
                  // event.stopPropagation();
                  onSelectionChange(notification, event.currentTarget.checked);
                }}
              />
            }
            label={
              <>
                {(areAllSelected || !!isSelected) && (
                  <Typography variant="caption">
                    Selected
                  </Typography>
                )}
              </>
            }
          />
          <Box sx={{ display: "flex", alignItems: "center", gap: "24px" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={notification.enabled}
                    sx={{ m: 1 }}
                    disabled={!!notification.isDisabled}
                    labelClassName={clsx("p-relative", style.switchLabel)}
                    onChange={(event) => {
                      event.preventDefault && event.preventDefault();
                      event.stopPropagation && event.stopPropagation();
                      onToggle(notification);
                    }}
                  />
                }
                sx={
                  !notification.enabled
                    ? {
                        "& .MuiFormControlLabel-label": {
                          ...globalStyles.text.color.disabled,
                        },
                      }
                    : {
                        "& .MuiFormControlLabel-label": {
                          color: "#6258de",
                          fontWeight: "bold",
                        },
                      }
                }
                label={notification.enabled ? "ON" : "OFF"}
              />
            </Box>
            <Dropdown
              customToggle={
                <img
                  src="/assets/more-action.svg"
                  alt="Edit"
                  style={{ cursor: "pointer" }}
                />
              }
              options={[
                {
                  label: (
                    <span style={{ marginBottom: 0, cursor: "pointer" }}>
                      <img
                        alt="Edit"
                        src="/assets/edit-default.svg"
                        style={{ marginRight: "8px" }}
                      />
                      Edit
                    </span>
                  ),
                  onClick: () => {
                    onMoreActionsChange({ actionType: "Edit" });
                  },
                },
                {
                  label: (
                    <span style={{ marginBottom: 0, cursor: "pointer" }}>
                      <img
                        alt="Duplicate"
                        src="/assets/duplicate-default.svg"
                        style={{ marginRight: "8px" }}
                      />
                      Duplicate
                    </span>
                  ),
                  onClick: () => {
                    onMoreActionsChange({ actionType: "Duplicate" });
                  },
                },
              ]}
              placement="bottom-end"
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            paddingTop: "12px",
          }}
          onClick={onCardClick}
        >
          {notification.call_direction === "Inbound" && (
            <img
              alt="inbound call direction icon"
              src={
                notification.enabled
                  ? "/assets/inbound-call.svg"
                  : "/assets/inbound-call-disabled.svg"
              }
              style={{
                backgroundColor: "#ebebeb",
                width: "60px",
                height: "60px",
                padding: "8px",
                borderRadius: "30px",
              }}
            />
          )}
          {notification.call_direction === "Outbound" && (
            <img
              alt="outbound call direction icon"
              src={
                notification.enabled
                  ? "/assets/outbound-call.svg"
                  : "/assets/outbound-call-disabled.svg"
              }
              style={{
                backgroundColor: "#ebebeb",
                width: "60px",
                height: "60px",
                padding: "8px",
                borderRadius: "30px",
              }}
            />
          )}
          {notification.call_direction === "Both Directions" && (
            <img
              alt="both direction call icon"
              src={
                notification.enabled
                  ? "/assets/bothdirections-call.svg"
                  : "/assets/bothdirections-call-disabled.svg"
              }
              style={{
                backgroundColor: "#ebebeb",
                width: "60px",
                height: "60px",
                padding: "8px",
                borderRadius: "30px",
              }}
            />
          )}
        </Box>
        <Box
          sx={
            !notification.enabled
              ? {
                  alignItems: "center",
                  marginTop: 1,
                  cursor: "pointer",
                  color: "grey",
                  textAlign: "center",
                }
              : {
                  alignItems: "center",
                  marginTop: 1,
                  cursor: "pointer",
                  textAlign: "center",
                }
          }
          onClick={onCardClick}
        >
          <Tooltip title={notification.name} placement="top">
            <Typography sx={{ marginBottom: "40px" }} variant="h6" noWrap>
              {notification.name}
            </Typography>
          </Tooltip>
        </Box>
        <Box
          sx={{
            ...style.tags,
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            gap: "6px",
            flexWrap:"wrap"
          }}
        >
          {(!!notification.emails || !!(notification.delay_config && !!notification.delay_config.find(elem => elem.type === DELIVERY_TYPE.EMAIL)) )&& (
            <Tag
              className={clsx("m-1", style.emailTag, {
                [style.tagDisabled]: !notification.enabled,
              })}
              icon={<img src="/assets/email-white.svg" alt="" />}
              label="Email"
              color={!notification.enabled ? "grey.400" : "#ffc617"}
            />
          )}
          {(!!notification.webhook || !!(notification.delay_config && !!notification.delay_config.find(elem => elem.type === DELIVERY_TYPE.WEBHOOK)) )&& (
            <Tag
              className={clsx("m-1", style.webhookTag, {
                [style.tagDisabled]: !notification.enabled,
              })}
              icon={<img src="/assets/webhook-white.svg" alt="" />}
              label="Webhook"
              color={!notification.enabled ? "grey.400" : "#ffa30a"}
            />
          )}
          {(!!notification.sms_to || !!(notification.delay_config && !!notification.delay_config.find(elem => elem.type === DELIVERY_TYPE.SMS)) ) && (
            <Tag
              className={clsx("m-1", style.smsTag, {
                [style.tagDisabled]: !notification.enabled,
              })}
              icon={<img src="/assets/phone-white.svg" alt="" />}
              label="SMS"
              color={!notification.enabled ? "grey.400" : "#ffa30a"}
            />
          )}
          {(!!notification.glip_teams || !!(notification.delay_config && !!notification.delay_config.find(elem => elem.type === DELIVERY_TYPE.GLIP))) && (
            <Tag
              className={clsx("m-1", style.glipTag, {
                [style.tagDisabled]: !notification.enabled,
              })}
              icon={<img src="/assets/glip.svg" alt="" />}
              label="Glip"
              color={!notification.enabled ? "grey.400" : "#f50"}
            />
          )}
          {(!!notification.ringout_to_number || !!(notification.delay_config && !!notification.delay_config.find(elem => elem.type === DELIVERY_TYPE.RINGOUT))) && (
            <Tag
              className={clsx("m-1", style.glipTag, {
                [style.tagDisabled]: !notification.enabled,
              })}
              icon={<img src="/assets/outbound-call-white.svg" alt="" />}
              label="Ringout"
              color={!notification.enabled ? "grey.400" : "#f50"}
            />
          )}
        </Box>
      </Paper>
    </>
  );
};

export default NotificationCardView;
